<template>
    <div class="wrapper">
        <main>
            <h1>404 Page Not Found</h1>
        </main>
    </div>
</template>

<script>
export default {
    title: '404 Page Not Found',
    description: ''
}
</script>

<style>
@import '../../assets/style/style.css';
</style>



// WEBPACK FOOTER //
// src/components/error/e404.vue